import { useMemo } from 'react';

import { Offer } from 'common/contracts';
import { extractActiveOfferIds } from 'views/Offers/Offer.utils';

interface IUsePopupOffersIdsProps {
  bundleOffers: Offer[] | undefined;
  promotionOffers: Offer[] | undefined;
}

interface IUsePopupOffersIdsReturn {
  offersIds: Array<{ content: string; key: string; value: string }>;
}

/**
 * Computes the list of active bundle and promotion offer IDs for popup trigger selectors.
 *
 * @example
 * const { offersIds } = usePopupOffersIds({
 *   bundleOffers: getBundleOffers?.data?.offers,
 *   promotionOffers: getPromotions?.data?.offers
 * });
 */
export const usePopupOffersIds = ({
  bundleOffers,
  promotionOffers
}: IUsePopupOffersIdsProps): IUsePopupOffersIdsReturn => {
  const offersIds = useMemo((): Array<{ content: string; key: string; value: string }> => {
    const bundles = extractActiveOfferIds(bundleOffers);
    const promotions = extractActiveOfferIds(promotionOffers);
    return [...bundles, ...promotions];
  }, [bundleOffers, promotionOffers]);

  return { offersIds };
};
